import React from 'react';
import { useIntl } from 'umi';
import { Radio } from 'tea-component';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import type { SelectorDimensionRadioProps, ISelectorDimensionOption } from './types';
import '@/pages/dashboard/assets/scss/page/components/selectShowValueType.scss';
import './index.scss';
export type { SelectorDimensionRadioProps, ISelectorDimensionOption } from './types';

const DEFAULT_OPTIONS: ISelectorDimensionOption[] = [
  { value: 'all', textEn: 'All', textCn: '全部' },
];

export default function SelectorDimensionRadio(props: SelectorDimensionRadioProps) {
  const {
    value = 'all',
    onChange,
    options = DEFAULT_OPTIONS,
    className,
    labelEn,
    labelCn,
    hideLabel = false,
  } = props;
  const { formatMessage } = useIntl();
  const { isEN } = useLocal();

  const label = labelEn && labelCn
    ? (isEN ? labelEn : labelCn)
    : formatMessage({ id: 'common_filter' });

  return (
    <div className={`dbd-select-radio dbd-select-radio-box ${className}`}>
      {!hideLabel && (
        <div className='title'>
          <span className='label'>
            {label}
          </span>
        </div>
      )}
      <div className='row'>
        <Radio.Group
          value={value}
          onChange={(val: string) => onChange?.(val)}
          className={`show-value-type`}
        >
          {options.map(option => (
            <Radio key={option.value} name={option.value}>
              {isEN ? option.textEn : option.textCn}
            </Radio>
          ))}
        </Radio.Group>
      </div>
    </div>
  );
}

